// Glass-i — HR Branches helpers (Stage HRMS-2). Pure JS.

let _rowIdCounter = 0;
function nextRowId() { _rowIdCounter += 1; return `hb-c-${_rowIdCounter}`; }

export function normalizeBranchRows(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map((r) => ({
    _clientRowId: r._clientRowId || (r.id ? `hb-${r.id}` : nextRowId()),
    _dirty:       false,
    id:           r.id || null,
    branchCode:   r.branchCode || '',
    branchName:   r.branchName || '',
    shortName:    r.shortName || '',
    city:         r.city || '',
    state:        r.state || '',
    phone:        r.phone || '',
    email:        r.email || '',
    active:       r.active !== false
  }));
}

export function markDirtyRow(rows, clientRowId, patch) {
  if (!Array.isArray(rows)) return [];
  return rows.map((r) => r._clientRowId === clientRowId ? { ...r, ...patch, _dirty: true } : r);
}

export function sortBranches(rows) {
  if (!Array.isArray(rows)) return [];
  return [...rows].sort((a, b) =>
    String((a && a.branchName) || '').localeCompare(String((b && b.branchName) || '')));
}

function trimOrNull(v) {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  return s ? s : null;
}

export function buildBranchBulkPayload(rows, deletedIds = []) {
  const dirty = (rows || []).filter((r) => r && r._dirty);
  return {
    rows: dirty.map((r) => {
      const out = {
        branchCode: trimOrNull(r.branchCode), branchName: trimOrNull(r.branchName),
        shortName: trimOrNull(r.shortName), city: trimOrNull(r.city), state: trimOrNull(r.state),
        phone: trimOrNull(r.phone), email: trimOrNull(r.email), active: r.active !== false
      };
      if (r.id) out.id = r.id;
      if (r._clientRowId) out._clientRowId = r._clientRowId;
      return out;
    }),
    deletes: Array.isArray(deletedIds) ? deletedIds.filter((id) => typeof id === 'string' && id.length > 0) : []
  };
}

export function validateBranchRows(rows) {
  const all = Array.isArray(rows) ? rows : [];
  const errors = [];
  for (const r of all) {
    const code = String(r.branchCode || '').trim();
    const name = String(r.branchName || '').trim();
    if (!code) errors.push({ field: 'branchCode', message: 'Branch Code is required.', clientRowId: r._clientRowId });
    if (!name) errors.push({ field: 'branchName', message: 'Branch Name is required.', clientRowId: r._clientRowId });
    const peers = all.filter((p) => p && p._clientRowId !== r._clientRowId);
    if (code && peers.some((p) => String(p.branchCode || '').trim().toLowerCase() === code.toLowerCase())) {
      errors.push({ field: 'branchCode', message: `Branch Code "${code}" already exists.`, clientRowId: r._clientRowId });
    }
    if (name && peers.some((p) => String(p.branchName || '').trim().toLowerCase() === name.toLowerCase())) {
      errors.push({ field: 'branchName', message: `Branch Name "${name}" already exists.`, clientRowId: r._clientRowId });
    }
  }
  return { ok: errors.length === 0, errors };
}
